export const buildFormData = (formData, data, parentKey) => {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    formData.append(parentKey, data);
  }
};

export const jsonToFormData = (data) => {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
};

/**
 * Function to check if a value is a number or fraction, and if it's fraction, we are getting the result of that
 * @param {*} value
 * @returns
 */
export const convertFractionToDecimal = (value) => {
  // Check if the value is a fraction
  if (typeof value === "string" && value.includes("/")) {
    const [numerator, denominator] = value.split("/").map(Number);
    const result = numerator / denominator;
    return parseFloat(result.toFixed(2));
  }

  // If it's a number we leave it as is
  const result = parseFloat(value);
  return parseFloat(result.toFixed(2));
};
